<template>
  <div class="table white-box">
    <table class="table-header">
      <thead>
        <tr>
          <th v-for="col in head" v-bind:class="classes(col)" v-bind:style="'width: ' + col.width + 'px'" v-html="col.html"></th>
        </tr>
      </thead>
    </table>
    <div class="table-body-wrapper">
      <table class="table-body" v-if="body.length > 0">
        <tbody>
          <tr v-for="(row, row_idx) in body" v-if="row.empty !== true" v-bind:data-key="row.key">
            <td
              v-for="(col, col_idx) in row.data"
              v-bind:class="classes(head[col_idx])"
              v-bind:style="'width: ' + head[col_idx].width + 'px'"
            >
              <span
                v-if="!col.link || col.edit"
                v-html="col.html"
                v-bind:name="head[col_idx].name"
                v-bind:data-placeholder="head[col_idx].placeholder"
                v-bind:contenteditable="col.edit" @input="tameContentEditable"
              ></span>
              <router-link v-else v-bind:to="col.link" v-html="col.html"></router-link>
              <button v-if="col_idx === 0 && row.editing_disabled !== true" class="edit-button" @click="edit(row_idx)"></button>
            </td>
          </tr>
          <tr v-else>
            <td
              v-for="col in head"
              v-bind:class="classes(col)"
              v-bind:style="'width: ' + col.width + 'px'">
              <span
                v-bind:contenteditable="!!col.name"
                v-bind:name="col.name"
                v-bind:data-placeholder="col.placeholder"
                @input="tameContentEditable"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="empty">This table is empty!</div>
    </div>
  </div>
</template>

<script>
import utils from "@/js/utils.js";

export default {
  name: "Table",
  props: ["head", "body", "name"],
  methods: {
    classes: col => {
      const alignments = {
        left: "align--left",
        center: "align--center",
        right: "align--right",
      }

      let alignment = alignments[col.align];
      if (!alignment) return col.class || "";

      col.class = col.class || "";
      return col.class + " " + alignment;
    },

    edit: function (idx) {
      if (this.body[idx].data.find(o => o.edit === true)) {
        let $row = this.$el.querySelector(`table tbody tr:nth-of-type(${ idx + 1 })`);
        this.$parent.$emit("save", { idx, data: utils.getFormInput($row), $row, name: this.name, key: this.body[idx].key });
      } else {
        this.$parent.$emit("edit", { idx, name: this.name });
      }
    },

    tameContentEditable: function (e) {
      if (e.target.innerText.trim() === "") e.target.innerText = "";
    }
  },
};
</script>

<style scoped>
.table td,
.table th {
  padding: 10px 0;
}

.table-header,
.table-body {
  padding: 0px 20px;
}

.table-header {
  padding-top: 10px;
}

.table-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.empty {
  font-style: italic;
  text-align: center;
  padding: 12px;
  opacity: 0.5;
  pointer-events: none;
}

table thead {
  opacity: 0.5;
}

table {
  width: 100%;
  text-align: left;
}

table .align--right {
  text-align: right;
}

table .align--left {
  text-align: left;
}

table .align--center {
  text-align: center;
}

table [contenteditable=true] {
  background: #ffeded;
  border-radius: 5px;
}

table [contenteditable=true]:empty::after {
  content: attr(data-placeholder);
  height: 39px;
  opacity: 0.5;
}

table .money span::before {
  content: "$";
}

span[contenteditable=true] {
  display: inline-block;
  padding: 4px;
  margin: -4px;
}

table .edit-button {
  pointer-events: none;
  opacity: 0;
  float: right;
  color: #2c3e5080;
  text-transform: uppercase;
  font-size: 0.8em;
  padding: 3px 5px;
  margin-right: 5px;
  margin-top: -1px;
  font-weight: 500;
  box-shadow: none;
}

table tr:hover .edit-button {
  pointer-events: all;
  opacity: 1;
}

.edit-button::after {
  content: "Edit";
}

[contenteditable=true] ~ .edit-button {
  opacity: 1;
  pointer-events: all;
}

[contenteditable=true] ~ .edit-button::after {
  content: "Save";
}

.table-body-wrapper {
  max-height: 500px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/generics/Table.vue